// import { LoyaltyRepository, TrainingsGroupRepository } from 'api/repository';
import { Box, DesktopItem, LoaderForm } from 'components';
import React, { ReactElement, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import './medical.scss';
import MedicalExaminationRepository from 'api/repository/MedicalExaminationRepository';
import { useUser } from 'store/userContext';
import useCheckColor from 'store/hooks/useCheckColor';

const Panel = (): ReactElement => {
  const { t } = useTranslation(['enum', 'employee']);

  const { userId, hydrated } = useUser();

  const [getMedicalExamination, dataMedicalExamination] =
    MedicalExaminationRepository.useGetMedicalExamination();

  useEffect(() => {
    if (userId && userId !== null) {
      getMedicalExamination({ userId });
    }
  }, [userId]);

  //   START Color

  const checkColor = useCheckColor();

  const DEADLINE_NAME_BY_EXAMINATION_TYPE: Record<
    string,
    | 'badanialekarskie'
    | 'pracownikpsychologiczne'
    | 'pracownikpsychiatryczne'
    | 'pracowniksanitarne'
    | 'pracownikpsychotesty'
  > = {
    MEDICAL: 'badanialekarskie',
    PSYCHIATRIC: 'pracownikpsychiatryczne',
    PSYCHOLOGICAL: 'pracownikpsychologiczne',
    PSYCHOTEST: 'pracownikpsychotesty',
    SANITARY: 'pracowniksanitarne',
    CHEMICAL_RESCUER: 'badanialekarskie',
  };

  // END Color

  return (
    <LoaderForm active={dataMedicalExamination === undefined} type="getData">
      <Box
        id="userMedicalDesktop"
        name={t(`employee:userMedicalDesktop.medical`)}
        svgIcon="desktop"
        noContentStyle
      >
        <>
          {dataMedicalExamination && dataMedicalExamination.length > 0 ? (
            <div className="userMedicalDesktopBox">
              {dataMedicalExamination && dataMedicalExamination !== null
                ? Object.keys(dataMedicalExamination).map((k) => {
                    return (
                      <DesktopItem
                        id="medical"
                        name={t(
                          `medicalExaminationType.${dataMedicalExamination?.[k]?.examinationType}`
                        )}
                      >
                        <>
                          {dataMedicalExamination?.[k]?.type !== null ? (
                            <div className="medicalDetailBox">
                              <div className="medicalLabel">
                                {t(`employee:userMedicalDesktop.medicalType`)}
                              </div>
                              <div className="medicalValue">
                                {t(
                                  `medicalType.${dataMedicalExamination?.[k]?.type}`
                                )}
                              </div>
                            </div>
                          ) : (
                            <div className="medicalDetailBox" />
                          )}

                          {dataMedicalExamination?.[k]?.positions !== null &&
                          Object.keys(dataMedicalExamination?.[k]?.positions)
                            ?.length > 0 ? (
                            <div className="medicalDetailBox">
                              <div className="medicalLabel">
                                {t(`employee:userMedicalDesktop.positions`)}
                              </div>
                              <div className="medicalValue">
                                {Object.values(
                                  dataMedicalExamination?.[k]?.positions ?? {}
                                ).join(', ')}
                              </div>
                            </div>
                          ) : (
                            ''
                          )}

                          {dataMedicalExamination?.[k]?.examinationDate !==
                          null ? (
                            <div className="medicalDetailBox">
                              <div className="medicalLabel">
                                {t(
                                  `employee:userMedicalDesktop.examinationDate`
                                )}
                              </div>
                              <div className="medicalValue">
                                {dataMedicalExamination?.[k]?.examinationDate}
                              </div>
                            </div>
                          ) : (
                            <div className="medicalDetailBox" />
                          )}

                          {dataMedicalExamination?.[k]?.expirationDate !== null
                            ? (() => {
                                return (
                                  <div
                                    className={`dateMedicalBox ${checkColor(
                                      dataMedicalExamination?.[k]
                                        ?.expirationDate,
                                      'pracownik',
                                      DEADLINE_NAME_BY_EXAMINATION_TYPE[
                                        dataMedicalExamination?.[k]
                                          ?.examinationType
                                      ]
                                    )}`}
                                  >
                                    <div
                                      className={`dateMedicalLabel ${checkColor(
                                        dataMedicalExamination?.[k]
                                          ?.expirationDate,
                                        'pracownik',
                                        DEADLINE_NAME_BY_EXAMINATION_TYPE[
                                          dataMedicalExamination?.[k]
                                            ?.examinationType
                                        ]
                                      )}`}
                                    >
                                      {t(
                                        `employee:userMedicalDesktop.expirationDate`
                                      )}
                                    </div>
                                    <div
                                      className={`dateMedicalValue ${checkColor(
                                        dataMedicalExamination?.[k]
                                          ?.expirationDate,
                                        'pracownik',
                                        DEADLINE_NAME_BY_EXAMINATION_TYPE[
                                          dataMedicalExamination?.[k]
                                            ?.examinationType
                                        ]
                                      )}`}
                                    >
                                      {
                                        dataMedicalExamination?.[k]
                                          ?.expirationDate
                                      }
                                    </div>
                                  </div>
                                );
                              })()
                            : ''}

                          <div className="borderTop" />
                        </>
                      </DesktopItem>
                    );
                  })
                : ''}
            </div>
          ) : (
            <></>
          )}
          {dataMedicalExamination === null ||
          (dataMedicalExamination && dataMedicalExamination.length === 0) ? (
            <div className="noMedical">Brak badań</div>
          ) : (
            <></>
          )}
        </>
      </Box>
    </LoaderForm>
  );
};

export default Panel;
